import { GridData } from '@shared/models/grid';
import { ListValue } from '.';

export interface ListValueGridData extends ListValue, GridData {}
